module.exports = __webpack_public_path__ + "static/media/06-04.5635105c.png";